import { render, staticRenderFns } from "./follow-task.vue?vue&type=template&id=a7435316&scoped=true&"
import script from "./follow-task.vue?vue&type=script&lang=js&"
export * from "./follow-task.vue?vue&type=script&lang=js&"
import style0 from "./follow-task.vue?vue&type=style&index=0&id=a7435316&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7435316",
  null
  
)

export default component.exports